import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ConcertCreateSellerUserResponseDto } from "../dto/concert.dto"
import { concertService } from "../services/concert.service"

export const useCreateConcertSellerUser = (): UseMutationResult<
  ConcertCreateSellerUserResponseDto,
  unknown,
  { userId: string }
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId }) => concertService.createSellerUser(userId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.concert.userStatuses,
      })
    },
  })
}
